<template>
  <div id="informe">
    <div class="row">
      <div class="col-6">
        <b-card title="Avance Diario" sub-title="Aplique Filtros">
          <table>
            <tr>
              <td><strong>Fecha:</strong>&nbsp;&nbsp;</td>
              <td>
                <b-form-input size="sm" v-model="avD.fecha" type="date" />
              </td>
              <td>&nbsp;&nbsp;<strong>Zona:</strong>&nbsp;&nbsp;</td>
              <td>
                <b-form-select
                  v-model="avD.zona"
                  :options="optionZonas"
                  class="mt-3"
                />
              </td>
            </tr>
          </table>

          <br />
          <vs-button @click="getxlxs()">Buscar</vs-button>
        </b-card>
        <hr style="border:2px;" />
        <table class="table table-responsive" style="font-size: 10px">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Documento</th>
              <th scope="col">Fecha</th>
              <th scope="col">Zona</th>
              <th scope="col">Analista</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in excel" :key="index">
              <th scope="row">
                <a
                  :href="
                    rutabase + 'Documentos/Descarga/' + data.documento_ruta
                  "
                  >Descarga</a
                >
              </th>
              <td>{{ data.documento_nombre }}</td>
              <td>{{ new Date(data.documento_fecha).toLocaleDateString() }}</td>
              <td>{{ data.zona.zona_nombre }}</td>
              <td>{{ data.user.user_name }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-6">
        <b-card title="Planos" sub-title="Aplique Filtros">
          <table>
            <tr>
              <td><strong>Busqueda Por SC</strong>&nbsp;&nbsp;</td>
              <td><b-form-input size="sm" v-model="map.sc" type="text" /></td>
              <td>&nbsp;&nbsp;<strong>Zona:</strong>&nbsp;&nbsp;</td>
              <td>
                <b-form-select
                  v-model="map.zona"
                  :options="optionZonas"
                  class="mt-3"
                />
              </td>
            </tr>
          </table>

          <br />
          <vs-button @click="getPlanos">Buscar</vs-button>
        </b-card>
        <hr style="border: 2px" />
        <table class="table table-responsive" style="font-size: 10px">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Documento</th>
              <th scope="col">Subcuenca</th>
              <th scope="col">Fecha</th>
              <th scope="col">Zona</th>
              <th scope="col">Analista</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in planos" :key="index">
              <th scope="row">
                <a
                  :href="
                    rutabase + 'Documentos/Descarga/' + data.documento_ruta
                  "
                  >Descarga</a
                >
              </th>
              <td>{{ data.documento_nombre }}</td>
              <td>{{ data.subcuenca_id }}</td>
              <td>{{ new Date(data.documento_fecha).toLocaleDateString() }}</td>
              <td>{{ data.zona.zona_nombre }}</td>
              <td>{{ data.user.user_name }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */

import Http from "../Http";
export default {
  name: "Ver-informe",
  data: () => ({
    rutabase: null,
    avD: {
      fecha: null,
      zona: null
    },
    map: {
      sc: null,
      zona: null
    },
    zonas: [],
    excel: [],
    planos: []
  }),
  computed: {
    optionZonas() {
      return this.zonas.map(x => ({ value: x.zona_id, text: x.zona_nombre }));
    },
    table() {
      return this.excel;
    }
  },
  mounted() {
    this.rutabase = Http.getUrl();
    Http.Http()
      .get("Documentos/zonas")
      .then(resp => {
        this.zonas = resp.data;
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    getxlxs() {
      if (this.avD.fecha != null && this.avD.zona != null) {
        Http.Http()
          .get(`Documentos/${this.avD.fecha}/${this.avD.zona}`)
          .then(resp => {
            this.excel = resp.data;
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    getPlanos() {
      if (this.map.sc != null && this.map.zona != null) {
        Http.Http()
          .get(`Documentos/Mapa/${this.map.zona}/${this.map.sc}`)
          .then(resp => {
            this.planos = resp.data;
          })
          .catch(err => {
            console.log(err);
          });
      }
    }
  }
};
</script>

<style scoped>
dataTable {
  font-size: 10px !important;
}
</style>
